import {logInProduction} from '$lib/utils/logInProduction';

export function getDeviceIsReadyPromise(browser: boolean, platform: string): Promise<void> {
    return new Promise((resolve) => {
        if (!browser) resolve()
        if (platform === 'web') {
            resolve()
        } else {
            document.addEventListener('deviceready', () => {
                logInProduction('>>> deviceready <<<')
                resolve()
            }, false);
        }
    })
}